(() => {
  if (!customElements.get('mmc-purchase-shortcut')) {
    customElements.define('mmc-purchase-shortcut', class extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        const signal = this.abort.signal;
        const root = () => document.getElementById('MainProduct-' + this.dataset.productSection);
        const button = () => root()?.querySelector('[name="add"]');
        const update = () => {
          const buy = button();
          const dialogOpen = document.querySelector('cart-drawer.active, dialog[open]');
          this.hidden = !buy || buy.getBoundingClientRect().bottom >= 0 || !!dialogOpen;
        };
        let queued = false;
        const onScroll = () => {
          if (queued) return;
          queued = true;
          requestAnimationFrame(() => { queued = false; update(); });
        };
        window.addEventListener('scroll', onScroll, { passive: true, signal });
        window.addEventListener('resize', onScroll, { passive: true, signal });
        this.querySelector('a').addEventListener('click', (event) => {
          const info = document.getElementById('ProductInfo-' + this.dataset.productSection);
          if (!info) return;
          event.preventDefault();
          const target = info.querySelector('variant-selects') || button() || info;
          const header = document.querySelector('sticky-header');
          const inset = (header?.getBoundingClientRect().height || 0) + 100;
          const top = Math.max(0, window.scrollY + target.getBoundingClientRect().top - inset);
          const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          window.scrollTo({ top, behavior: reduce ? 'instant' : 'smooth' });
          const focus = target.querySelector('input:checked, select, button') || button();
          focus?.focus({ preventScroll: true });
        }, { signal });
        update();
      }
      disconnectedCallback() { this.abort?.abort(); }
    });
  }
  if (!customElements.get('mmc-photo-gallery')) {
    customElements.define('mmc-photo-gallery', class extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        const signal = this.abort.signal;
        const track = this.querySelector('[data-gallery-track]');
        const prev = this.querySelector('[data-gallery-prev]');
        const next = this.querySelector('[data-gallery-next]');
        if (!track || !prev || !next) return;
        const update = () => {
          const left = Math.abs(track.scrollLeft);
          prev.disabled = left < 2;
          next.disabled = left >= track.scrollWidth - track.clientWidth - 2;
        };
        const move = direction => {
          const first = track.firstElementChild;
          const step = (first?.getBoundingClientRect().width || track.clientWidth) + 16;
          const rtl = getComputedStyle(track).direction === 'rtl' ? -1 : 1;
          const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          track.scrollBy({ left: step * direction * rtl, behavior: reduce ? 'instant' : 'smooth' });
        };
        prev.addEventListener('click', () => move(-1), { signal });
        next.addEventListener('click', () => move(1), { signal });
        track.addEventListener('scroll', update, { passive: true, signal });
        this.observer = new ResizeObserver(update); this.observer.observe(track);
        update();
      }
      disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); }
    });
  }
})();

(() => {
  if (customElements.get('mmc-delivery-estimate')) return;
  customElements.define('mmc-delivery-estimate', class extends HTMLElement {
    connectedCallback() {
      const render = () => {
        const value = key => Math.max(0, Math.min(30, Number(this.dataset[key]) || 0));
        const processingMin = value('processingMin');
        const processingMax = Math.max(processingMin, value('processingMax'));
        const transitMin = value('transitMin');
        const transitMax = value('transitMax');
        const delivery = transitMin > 0 && transitMax >= transitMin;
        const businessDate = days => {
          const date = new Date(); date.setHours(12, 0, 0, 0);
          while (days > 0) { date.setDate(date.getDate() + 1); if (date.getDay() !== 0 && date.getDay() !== 6) days--; }
          return date;
        };
        const first = businessDate(processingMin + (delivery ? transitMin : 0));
        const last = businessDate(processingMax + (delivery ? transitMax : 0));
        const language = document.documentElement.lang || 'en-US';
        const format = new Intl.DateTimeFormat(language, { month: 'short', day: 'numeric', year: 'numeric' });
        const dates = first.getTime() === last.getTime() ? format.format(first) : format.formatRange(first, last);
        this.querySelector('[data-delivery-window]').textContent = (delivery ? 'Estimated US delivery: ' : 'Estimated dispatch: ') + dates;
      };
      render(); this.timer = setInterval(render, 60000);
    }
    disconnectedCallback() { clearInterval(this.timer); }
  });
})();
